<div class="row mt-2 mb-2">
  <div class="col-3">
    <div class="input-group">
      <input type="number" class="form-control unfocus" id="windowTime" placeholder="Enter Window Time" [min]="1" [max]="60" [(ngModel)]="selectedWindowTime" [ngClass]="{ 'is-invalid': submitted && !selectedWindowTime }" required>
      <button class="btn btn-outline-success" (click)="generate_new_data()" type="button" id="button-addon2">Generate</button>
    </div>
  </div>
  <div class="col-3">
    <span class="text-danger">{{ errorMessage }}</span>
  </div>
</div>

<div class="heatmap" style="max-height: 280px;">
  @if (ready) {
    <ngx-charts-line-chart #chart1 class="dark"
      [scheme]="colorScheme"
      [results]="chartData"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [curve]="curve"
      [yScaleMin]="min"
      [yScaleMax]="max"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [animations]="animations"
      [showGridLines]="showGridLines"
      [roundDomains]="roundDomains">
    </ngx-charts-line-chart>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 280px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>